import { jsPDF } from "jspdf";

export const generateReceiptPDF = (receiptData) => {
  const doc = new jsPDF();

  doc.text("Transaction Receipt", 10, 10);
  doc.text(`Invoice ID: ${receiptData.invoice_id}`, 10, 20);
  doc.text(`Cashier ID: ${receiptData.cashier_id}`, 10, 30);
  doc.text(`Date/Time: ${receiptData.created_at}`, 10, 40);
  doc.text(`Payment Method: ${receiptData.payment_method}`, 10, 50);
  doc.text(`Amount: $${receiptData.amount}`, 10, 60);

  return doc.output("blob");
};

export const handleDownloadReceipt = async (fetchTransactionReceipt, transactionId) => {
  try {
    const receiptData = await fetchTransactionReceipt(transactionId);

    if (!receiptData) {
      throw new Error("Failed to fetch receipt data.");
    }

    const receiptBlob = generateReceiptPDF(receiptData);
    const url = URL.createObjectURL(receiptBlob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "receipt.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading receipt:", error);
    throw error;
  }
};

export const handleShareReceipt = (receiptData) => {
  try {
    if (navigator.share) {
      const shareData = {
        title: "Transaction Receipt",
        text: `Invoice ID: ${receiptData.invoice_id}\nCashier ID: ${receiptData.cashier_id}\nDate/Time: ${receiptData.created_at}\nPayment Method: ${receiptData.payment_method}\nAmount: $${receiptData.amount}`,
        url: window.location.href,
      };

      return navigator.share(shareData);
    } else {
      const receiptText = `Invoice ID: ${receiptData.invoice_id}\nCashier ID: ${receiptData.cashier_id}\nDate/Time: ${receiptData.created_at}\nPayment Method: ${receiptData.payment_method}\nAmount: $${receiptData.amount}`;
      return navigator.clipboard.writeText(receiptText).then(() => {
        alert("Receipt details copied to clipboard!");
      });
    }
  } catch (error) {
    console.error("Error sharing receipt:", error);
    throw error;
  }
};